<script setup lang="ts">
import { computed, onMounted, onUnmounted, reactive } from "vue";
import { roomState, serverDiffTime } from "../../../states/room";

const time = reactive({
  h: 0,
  m: 0,
  s: 0,
});
let interval: NodeJS.Timeout | null = null;
onMounted(() => {
  interval = setInterval(() => {
    let duration =
      Date.now() - new Date(roomState.startCall as string).getTime() - serverDiffTime.value;
    duration = Math.floor(duration / 1000);
    time.s = duration % 60;
    let mins = Math.floor(duration / 60);
    time.m = mins % 60;
    let h = Math.floor(mins / 60);
    time.h = h % 24;
  }, 1000);
});
onUnmounted(() => {
  if (interval) {
    clearInterval(interval);
  }
});
function toDigitValue(v: number) {
  return ("000" + String(v)).slice(-2);
}
const visible = computed(() => {
  return `${time.h}:${toDigitValue(time.m)}:${toDigitValue(time.s)}`;
});
</script>
<template>
  <div class="content">{{ visible }}</div>
</template>
<style scoped>
.content {
  color: #a4a4a4;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
</style>
